<div class="col-12" style=" margin-top: 15px;">
    <h4> {{"yourpettype"| transloco }}</h4>
</div>
<div class="scroll-menu">

    <div class="scroll-item" (click)="byPet('cats',0)" id="0">
        <img src="/assets/e-commerce/icons/8.webp">
        <p>{{ "cats" | transloco }}

        </p>
    </div>
    <div class="scroll-item" (click)="byPet('dogs',1)">
        <img src="/assets/e-commerce/icons/11.webp">
        <p>{{ "dogs" | transloco }}</p>

    </div>
    <div class="scroll-item clinic-new" routerLink="/clinic">
  <span class="new-flag">{{ "NEW" | transloco }}</span>

  <img src="/assets/e-commerce/icons/93.webp">
  <p>{{ "clinic" | transloco }}</p>
</div>
    <div class="scroll-item" (click)="byPet('catsanddogs',4)">
        <img src="/assets/e-commerce/icons/10.webp">
        <p>{{ "cats&dogs" | transloco }}</p>
    </div>
    <div class="scroll-item" (click)="byPet('birds',2)">
        <img src="/assets/e-commerce/icons/13.webp">
        <p>{{ "birds" | transloco }}</p>
    </div>
    <div class="scroll-item" (click)="byPet('other',3)">
        <img src="/assets/e-commerce/icons/25.png">
        <p>{{ "other" | transloco }}</p>
    </div>

</div>